// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XsGJP","importantInfo":"styles_importantInfo__2zFtD"};